import styled, {css} from "styled-components"
import elevation from "@irati/ui/src/global/elevation"

const Wrapper = styled.div`
  ${({theme}) => css`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: ${theme.border.radius.extraLarge};
    cursor: pointer;
    padding: ${theme.spacing.one};
    ${elevation.twoPxHighlight}
    background-color: ${theme.colors.greys.white};
    color: ${(props) => (props.active ? theme.colors.perkbox.blue : theme.colors.fontColor)};
    transition: color 0.3s ease-in, box-shadow 0.3s ease-in-out;

    ${(props) =>
            props.isReaction &&
            `
    position: relative;
    top: -3px;
  `}
    &:hover {
      color: ${theme.colors.perkbox.blue};
      box-shadow: 0 2px 3px 2px rgba(61, 61, 54, 0.1), 0 0 3px 0 rgba(61, 61, 54, 0.1), 0 0 3px 1px ${theme.colors.perkbox.blue};
    }

    svg {
      pointer-events: none;
      transition: color 0.3s ease-in, fill 0.3s ease-in;
    }
  `}
`

export default Wrapper
